<template>
  <div class="pa-3 mb-3 d-flex align-center">
    <div
      v-if="loading"
      class="d-flex align-center"
      style="width: 100%; min-height: 200px"
    >
      <v-row no-gutters align="center">
        <v-col cols="12" md="3" class="d-flex justify-center align-center my-3">
          <v-skeleton-loader
            width="45%"
            height="10vh"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="9">
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div v-if="!loading && myData" style="width: 100%">
      <v-row no-gutters>
        <v-col cols="12" sm="3" md="3" lg="3">
          <div style="position: relative;width:150px;height;150px;">
            <div>
              <v-avatar size="150">
                <img
                  :src="myData.profile_picture ? myData.profile_picture : ava"
                  class="obj_fit"
                />
              </v-avatar>
            </div>
            <div style="position: absolute; top: 100px; right: -5px">
              <v-btn
                depressed
                fab
                color="blue"
                small
                dark
                @click="$refs.file.click()"
              >
                <input
                  type="file"
                  ref="file"
                  @change="uploadImage($event)"
                  accept="image/*"
                  class="input_hide"
                />
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="8" md="8" lg="8">
          <div>
            <h4>
              {{ myData.name.charAt(0).toUpperCase() + myData.name.slice(1) }}
            </h4>
            <div class="mt-2 d-flex">
              <v-card
                flat
                color="#0063414D"
                class="rounded-pill mr-2 mb-2 py-2 px-3"
              >
                <h5 style="color: #006341">
                  {{ role == "TF" ? "Admin TF" : "Vendor" }}
                </h5>
              </v-card>
            </div>
            <v-row no-gutters style="width: 100%">
              <v-col cols="12" md="6">
                <div class="d-flex align-center my-2">
                  <v-icon color="#006341" class="mr-4"> mdi-at </v-icon>
                  <h4 style="color: rgba(0, 0, 0, 0.6)">
                    {{ myData.username }}
                  </h4>
                </div>
                <div class="d-flex align-center my-2">
                  <v-icon color="#006341" class="mr-4">
                    mdi-card-account-details
                  </v-icon>
                  <h4 style="color: rgba(0, 0, 0, 0.6)">
                    {{ myData.nik }}
                  </h4>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center my-2">
                  <v-icon color="#006341" class="mr-4"> mdi-email </v-icon>
                  <h4 style="color: rgba(0, 0, 0, 0.6)">
                    {{ myData.email }}
                  </h4>
                </div>
                <div class="d-flex align-center my-2">
                  <v-icon color="#006341" class="mr-4">
                    mdi-gender-{{
                      myData.gender == "Male" ? "male" : "female"
                    }}
                  </v-icon>
                  <h4 style="color: rgba(0, 0, 0, 0.6)">
                    {{ myData.gender }}
                  </h4>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" sm="1" md="1" lg="1">
          <div class="d-flex align-start justify-end">
            <v-btn
              x-small
              fab
              depressed
              color="#006341"
              @click="$emit('uprofile')"
            >
              <v-icon color="white">mdi-pencil-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <dialog-medium
      :d_create="d_create"
      @refetch="$emit('refetch')"
      @close="d_create = false"
      :inventory="inventory"
      :type="d_type"
      :title="d_title"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      d_create: false,
      inventory: "",
      d_type: "",
      d_title: "",
      image: {
        src: "",
        type: "image/jpg",
      },
    };
  },
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
      ava: (state) => state.ava_lg,
    }),
  },
  name: "profile",
  props: ["myData", "loading"],

  methods: {
    updatePhotoProfile() {
      this.d_type = "u_photoProfileTF";
      this.d_title = "Update Photo";
      this.d_create = true;
      this.inventory = this.dataSet;
    },
    // CROP STUFF
    uploadImage(event) {
      /// Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
        this.image = {
          src: blob,
          type: files[0].type,
        };
        this.showCrop();
      }
    },
    showCrop() {
      this.d_type = "crop";
      this.d_title = "Change profile picture";
      this.d_create = true;
      this.inventory = this.image;
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: center;
}
.input_hide {
  display: none;
}
</style>
